export default __webpack_public_path__ + "static/media/project.2125ae22.svg";